import {
  InnerBlocks,
  useBlockProps,
  useInnerBlocksProps,
} from '@wordpress/block-editor';

import ResponsiveImage from '@components/ui/ResponsiveImage';
import ResponsiveVideo from '@components/ui/ResponsiveVideo';

export default function save({ attributes }) {
  const {
    linkUrl,
    linkTitle,
    linkTarget,
    linkTile,
    media,
    mediaClass,
    flexClass,
    metadata,
  } = attributes;

  const blockProps = useBlockProps.save({
    className: `bf_relative`,
  });

  // set innerBlockProps classes
  const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
    className: `bf_layout ${flexClass}`,
  });
  return (
    <div {...blockProps}>
      {media.id ? (
        <>
          {media.type === 'video' ? (
            <ResponsiveVideo media={media} mediaClass={`${mediaClass}`} />
          ) : (
            <ResponsiveImage media={media} mediaClass={`${mediaClass}`} />
          )}
        </>
      ) : null}
      {linkUrl ? (
        <a
          rel="noopener noreferrer"
          target={linkTarget}
          href={linkUrl}
          title={linkTitle}
          className="bf_tile"
        ></a>
      ) : null}
      <div {...innerBlocksProps}>{children}</div>
    </div>
  );
}
